define('js/lib/getInviteErrorMessage',[],function () {
    'use strict';

    function getConfigErrorMessage(error) {
        var code = error.code;
        switch (code) {
        case 401:
            return 'Sorry, this invite link has expired.';
        case 403:
            return 'Sorry, you do not have access to this Display.';
        case 404:
            return 'Sorry, this invite does not exist, or has been deactivated.';
        default:
            return error.message || 'Invite link failed. Status Code: ' + code;
        }
    }

    return {
        get: getConfigErrorMessage
    };
});
